import colors from "theme/colors"

const SvgComponent = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="נשלח בהצלחה"
    >
      <g clip-path="url(#clip0_15796_83166)">
        <path
          d="M7.60571 16.0021L13.2016 21.5979L24.3932 10.4062"
          stroke={colors.successGreen}
          stroke-width="2.09844"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_15796_83166">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgComponent
